/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.learning.center.credentials.rpc.PlaylistVisibilityChirpService
 */
import { createRpcClientV2 } from 'rpc-client-utils';
import { registerQuery } from 'data-fetching-client/next';
import http from 'hub-http/clients/apiClient';
import * as References from './PlaylistVisibilityChirpService';
const chirpClient = createRpcClientV2({
  hubHttpClient: http
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.learning.center.credentials.rpc.PlaylistVisibilityChirpService#getAllUserPlaylistProgress
 */
export const GET_ALL_USER_PLAYLIST_PROGRESS_QUERY_FIELD_NAME = 'com_hubspot_learning_center_credentials_rpc_PlaylistVisibilityChirpService_getAllUserPlaylistProgress';
export const GET_ALL_USER_PLAYLIST_PROGRESS_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_ALL_USER_PLAYLIST_PROGRESS_QUERY_FIELD_NAME,
  args: ['assignedBy', 'teamMembers', 'teams', 'playlists', 'playlistNameQuery', 'status', 'dueDate', 'completedAt', 'sortOrder', 'sortField', 'pageLength', 'offset'],
  fetcher(request, ctx) {
    var _ctx$customClient;
    return ((_ctx$customClient = ctx.customClient) !== null && _ctx$customClient !== void 0 ? _ctx$customClient : chirpClient).call(References.getAllUserPlaylistProgressRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.learning.center.credentials.rpc.PlaylistVisibilityChirpService#getAssignedPlaylistsForPortal
 */
export const GET_ASSIGNED_PLAYLISTS_FOR_PORTAL_QUERY_FIELD_NAME = 'com_hubspot_learning_center_credentials_rpc_PlaylistVisibilityChirpService_getAssignedPlaylistsForPortal';
export const GET_ASSIGNED_PLAYLISTS_FOR_PORTAL_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_ASSIGNED_PLAYLISTS_FOR_PORTAL_QUERY_FIELD_NAME,
  args: ['playlistNameQuery'],
  fetcher(request, ctx) {
    var _ctx$customClient2;
    return ((_ctx$customClient2 = ctx.customClient) !== null && _ctx$customClient2 !== void 0 ? _ctx$customClient2 : chirpClient).call(References.getAssignedPlaylistsForPortalRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});